module.exports = __webpack_public_path__ + "img/title-dver-1-t@2x.2135929b.png";